import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_LAYERS: "SET_LAYERS",
  SET_ENTITY_PROPS: "SET_ENTITY_PROPS",
  SET_COMPUTED_LAYERS: "SET_COMPUTED_LAYERS",
  SET_ENTITY_MODELS: "SET_ENTITY_MODELS",
  SET_ACTIVE_LAYERS: "SET_ACTIVE_LAYERS",
  SET_STATIC_LAYERS: "SET_STATIC_LAYERS",
  SET_ACTIVE_STATIC_LAYERS: "SET_ACTIVE_STATIC_LAYERS",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Sets the list of layers in the layer registry
   * @param {Object} state
   * @param {Array} data
   */
  [types.SET_LAYERS]: (state, data) => {
    state.layerRegistry = data;
  },

  /**
   * Sets the list of entity properties. a.k.a Layers inside Cohorts/EntityModels
   */
  [types.SET_ENTITY_PROPS]: (state, data) => {
    state.entityProps = data;
  },

  /**
   * Sets the list of computed layers
   */
  [types.SET_COMPUTED_LAYERS]: (state, data) => {
    state.computedLayers = data;
  },

  /**
   * Sets the list of Entity Models/Cohorts
   */
  [types.SET_ENTITY_MODELS]: (state, data) => {
    state.entityModels = data;
  },

  /**
   * Sets the list of Active Layers
   */
  [types.SET_ACTIVE_LAYERS]: (state, data) => {
    state.activeLayers = data;
  },

  /**
   * Set overlay layers
   */
  [types.SET_STATIC_LAYERS]: (state, data) => {
    state.staticLayers = data;
  },
  /***
   * Sets list of active static layers
   */
  [types.SET_ACTIVE_STATIC_LAYERS]: (state, data) => {
    state.activeStaticLayers = data;
  },
};
